
export const formatDateTime = (timeString: string) => {
  if (!timeString) return '';
  return new Intl.DateTimeFormat('vi-VN', {dateStyle:'short',timeStyle: "short"}).format(new Date(timeString))
}
